export enum UserSessionStorageKeys {
    ActiveBookingToken = 'activeBooking.token',
    ActiveBookingInitialData = 'activeBooking.initialData',
    ActiveBookingSearchControllerStorage = 'activeBooking.searchControllerStorage',
    BookingSessionStorage = 'booking.sessionStorage',

    FlightSearchSearchControllerStorage = 'flightSearch.searchControllerStorage',
    FlightSearchPsoPopperFirstTimeShown = 'flightSearch.psoPopperFirstTimeShown',


    BookingRetrieveSearchParams = 'bookingRetrieve.searchParams',
    BookingsSearchFiltersValues = 'bookingsSearch.filters.values',


}